var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99667 0.25C9.37636 0.25 9.69021 0.532013 9.73995 0.898078L9.74682 0.999848L9.74802 8.25H17.0011C17.4153 8.25 17.7511 8.58579 17.7511 9C17.7511 9.3797 17.469 9.69349 17.1029 9.74315L17.0011 9.75H9.74802L9.75007 16.9991C9.75015 17.4133 9.41443 17.7493 9.00022 17.7493C8.62053 17.7493 8.30667 17.4673 8.25694 17.1012L8.25007 16.9994L8.24802 9.75H0.999023C0.58481 9.75 0.249023 9.41421 0.249023 9C0.249023 8.6203 0.531177 8.30651 0.897253 8.25685L0.999023 8.25H8.24802L8.24682 1.00015C8.24673 0.585939 8.58245 0.25 8.99667 0.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.dfeeeeeb1b5c12ee22c27680a80fe0e5.svg";
export { ForwardRef as ReactComponent };